import ApiConnector from '@/backend/apiModels/CRUDrequest'
import { useRouter } from 'vue-router';
import { useErrorHandler } from '@/hooks/errorHandler';
import { hasExecutorSearchFilters, buildExecutorSearchParams } from '@/pages/securityCheck/helpers/executorSearchPayload.mjs';
import { invalidateCarDetail, invalidateCarsQueries } from '@/queryClient'

const EXECUTORS_PER_PAGE = 20;
let executorsListRequestSeq = 0;

function nextExecutorsListRequest() {
  executorsListRequestSeq += 1;
  return executorsListRequestSeq;
}

function isExecutorsListRequestCurrent(seq) {
  return seq === executorsListRequestSeq;
}
// import { createToaster } from "@meforma/vue-toaster";

// const toaster = createToaster();
// const router = useRouter()
const namespaced = true

function processActivities(activities) {
  const datasets = [];
  let date_datasets = []

  activities.forEach(activity=>{
    const dates = JSON.parse(activity.dates);
    const values = JSON.parse(activity.values);
    
    if(!dates) return null

    if(dates.length>date_datasets.length){
      date_datasets = dates
    }
    const dataset = {
      label: activity.title,
      data: values
    }

    datasets.push(dataset);
    
  })

  return {datasets,date_datasets}
}

const state = {
  options:{
    api: new ApiConnector('security_options'),
    checkParams:{}
  },
  executors:{
    api: new ApiConnector('executors'),
    searchList:[],
    isSearchActive: false,
    lastSearchForm: null,
    items:{
        data:[],
        currentPage: 1,
        totalPages:1,
        loading:false,
    },
    item:{
        data:{},
        errors:[],
        loading:false,
    }
  },
  drivers:{
    api: new ApiConnector('drivers'),
    searchList:[],
    items:{
        data:[],
        currentPage: 1,
        totalPages:1,
        loading:false,
    },
    item:{
        data:{},
        loading:false,
    }
  },

  companies:{
    api: new ApiConnector('companies'),
    searchList:[],
    items:{
        data:[],
        currentPage: 1,
        totalPages:1,
        loading:false,
    },
    item:{
        data:{},
        loading:false,
    }
  },
  managers:{
    api: new ApiConnector('managers'),
    searchList:[],
    items:{
        data:[],
        currentPage: 1,
        totalPages:1,
        loading:false,
    },
    item:{
        data:{},
        loading:false,
    }
  },
  cars:{
    api: new ApiConnector('cars'),
    searchList:[],
    items:{
        data:[],
        currentPage: 1,
        totalPages:1,
        loading:false,
    },
    item:{
        data:{},
        loading:false,
    }
  },
  
};

const mutations = {
  setChackParams(state,response){
    state.options.checkParams = response
  },
  updateDriver(state,response){
    state.executors.item.data.driver = response
  },
  updateExecutorCarTrailer(state,{model,response}){
    state.executors.item.data[model] = response
  },
  updateExecutorManager(state,{response}){
    state.executors.item.data.manager = response
  },
  
  setDataModel(state,{model, response}){
    state[model].item.data = response.value
  },

  setSearchList(state,{model, response}){
    state[model].searchList = response.value
  },

  setListDataModel(state,{model, response}){
    state[model].items.data = response.value[model]
    state[model].items.currentPage = response.value.current_page
    state[model].items.totalPages = response.value.total_pages
  },

  setSearchState(state, { active, form = null }) {
    state.executors.isSearchActive = active
    state.executors.lastSearchForm = form
  },

  setItemDataModel(state,{model, response}){
    state[model].item.data = response.value
  },

  setLoading(state, { model, status, type }) {
    state[model][type].loading = status
  },

};

const getters = {
  getExecutorErrors(state){
    return state.executors.item.errors.map(error => {
      return error.msg
    })
  },

  getApproval(state){
    if(state.executors.item.data.errors){
      const  block = state.executors.item.data.errors.filter(err => err.block === true)
      if (block.length >0){
        return true
      }
    }
    return false
  },

  getDatasetsExecutor(state){
    const activities = state.companies.item.data.company.activities
    if (!activities) return null;
    return processActivities(activities);
  },
};

const actions = {

  async waitInterval({ dispatch },{func,params,seconds=120}){
      setTimeout(() => {
        dispatch(func,params);  
      }, seconds*1000);
  },

  async startLoading({ commit },{request,model,type,silence}){
    

    if(!silence) commit('setLoading', {model,type,status:true})
    try{
      await request()
    }catch(error){
      const path = useErrorHandler(error)
      // if(path){
      //   router.push(path)
      // } 
    }  
  },

  async getSearchList({ dispatch, commit },{model,params}){
    const api = state[model].api
    const { response, request } = api.get('/search-list',{params})
    await dispatch('startLoading', { request, model ,silence:true });
    if (response.value) {
      commit('setSearchList', {model,response});
    }
  },

  async getItems({ dispatch, commit },{model,params,silence}){
    const api = state[model].api
    const requestParams = {
      page: params?.page || 1,
      per_page: params?.per_page || EXECUTORS_PER_PAGE,
    }
    const requestSeq = model === 'executors' ? nextExecutorsListRequest() : null
    const { response, request } = api.get('',{params: requestParams})
    await dispatch('startLoading', { request, model ,type:'items',silence });

    if (
      response.value
      && (model !== 'executors' || isExecutorsListRequestCurrent(requestSeq))
    ) {
      commit('setListDataModel', {model,response});
    }

    if (!silence) {
      commit('setLoading', { model,type:'items', status: false });
    }
  },

  async getItem({ dispatch, commit },{model,id,silence}){
    const api = state[model].api
    const { response, request } = api.get(id.toString(),{params:{}})
    await dispatch('startLoading', { request, model ,type:'item',silence });
    if(response.value){
      commit('setDataModel',{model,response})
    }
    commit('setLoading', { model,type:'item', status: false });
  },

  async searchExecutorByCompany({ dispatch, commit }, { form, page = 1 }) {
    await dispatch('searchExecutorsFiltered', { form, page });
  },

  /**
   * POST /api/v2/executors/search?page=&per_page=
   * Body: ExecutorSearch
   */
  async searchExecutorsFiltered({ dispatch, commit }, { form, page = 1 }) {
    const hasFilters = hasExecutorSearchFilters(form)
    if (!hasFilters) {
      await dispatch('resetSearch', { page, model: 'executors' })
      return
    }

    const requestSeq = nextExecutorsListRequest()
    const api = state.executors.api
    const { response, request } = api.post('/search', {
      form,
      params: buildExecutorSearchParams(form, page, EXECUTORS_PER_PAGE),
    })

    await dispatch('startLoading', { request, model: 'executors', type: 'items' })

    if (response.value && isExecutorsListRequestCurrent(requestSeq)) {
      commit('setListDataModel', { model: 'executors', response })
      commit('setSearchState', { active: true, form })
    }
    commit('setLoading', { model: 'executors', type: 'items', status: false })
  },

  async reapplySearch({ dispatch, state }, { page = 1 }) {
    const form = state.executors.lastSearchForm
    if (!form) {
      await dispatch('getItems', { params: { page }, model: 'executors' })
      return
    }
    await dispatch('searchExecutorsFiltered', { form, page })
  },

  async resetSearch({ dispatch, commit }, { page = 1, model = 'executors' }) {
    commit('setSearchState', { active: false, form: null })
    await dispatch('getItems', { params: { page }, model })
  },

  async updateItem({ dispatch, commit },{id,form,model}){
    
    const api = state[model].api
    const { response, request } = api.put(id.toString(),form)

    await dispatch('startLoading', { request, model ,type:'item',silence:true });
    if(response.value){
      commit('setDataModel',{model,response})
    }
    commit('setLoading', { model,type:'item', status: false });
  },

  async updateSecureOptions({commit}){
    const { response, request } = state.options.api.get('',{params:null})
    try{
      await request()
    }catch(err){
      console.log(err)
    }
    
    if(response.value){
      commit('setChackParams',response)
    }
    
  },

  async UpdateBank({ dispatch,commit },{form}){
    const { response, request } = state.companies.api.put('bank-details/'+form.id,form)

    await dispatch('startLoading', { request, model:'companies' ,type:'item',silence:true });
  },

  async deleteBank({ dispatch,commit },{id}){
    const { response, request } = state.companies.api.delete('bank-details/'+id)

    await dispatch('startLoading', { request, model:'companies' ,type:'item',silence:true });
  },

  async AddBank({ dispatch,commit },{form,company_id}){
    const { response, request } = state.companies.api.post(company_id+'/bank-details',{form})

    await dispatch('startLoading', { request, model:'companies' ,type:'item',silence:true });
    // if(response.value){
    //   await commit('updateExecutorCarTrailer',{model:'car',response:response.value})
    // }else{
    //   return null
    // }
  },

  async updateSecure({ dispatch,commit },{form,model}){
    let api_model = model
    if (model == 'trailers' || model == 'cars'){
      api_model = 'cars'
    }
    const api = state[api_model].api
    const { response, request } = form.id ? api.put('',form) : api.post('',form)

    await dispatch('startLoading', { request, model ,type:'item',silence:true });
    
    if(response.value){
      if (model == 'cars'){
        await commit('updateExecutorCarTrailer',{model:'car',response:response.value})
        await invalidateCarDetail(form?.id || response.value?.id)
      }else{
        await commit('updateExecutorCarTrailer',{model:'trailer',response:response.value})
        if (model == 'trailers') {
          await invalidateCarsQueries()
        }
      }
      return response.value
    }else{
      return null
    }
    
  },

  async updateCar({ dispatch,commit },{form}){
    const api = state.car.api
    const { response, request } = form.id ? api.put('',form) : api.post('',form)

    await dispatch('startLoading', { request, model:'cars' ,type:'item',silence:true });
    
    if(response.value){
      await commit('updateExecutorCarTrailer',{model:'car',response:response.value})
      await invalidateCarDetail(form?.id || response.value?.id)
      return response.value
    }else{
      return null
    }
    
  },

  async confirmManager({ dispatch,commit },{managerForm}){
    const { response, request } = state.managers.api.put('',managerForm)

    await dispatch('startLoading', { request, model:'managers' ,type:'item',silence:true });
    
    if(response.value){
      await commit('updateExecutorManager',{response:response.value})

    }
    
  },

  /**
   * DELETE /api/v2/executors/{id}
   * Backend: { executor_id, deleted }. deleted=false → недостаточно прав.
   */
  async deleteExecutor({ dispatch }, { id }) {
    const api = state.executors.api
    const { response, request } = api.delete(id)
    await dispatch('startLoading', {
      request,
      model: 'executors',
      type: 'item',
      silence: true,
    })
    return response.value
  },

};

export default {
  state,
  mutations,
  getters,
  actions,
  namespaced
};